// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

export default function InputLabel(theme: Theme) {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.grey[500],
          fontSize: '0.75rem',
          '&[data-shrink="false"]': {
            margin: '2px 0 4px 0',
            color: theme.palette.text.secondary
          },
          paddingBottom: '4px'
        },
        outlined: {
          lineHeight: '0.8em',
          // '&.MuiInputLabel-sizeSmall': {
          //   lineHeight: '1.2em'
          // },
          '&.MuiInputLabel-shrink': {
            padding: '4px 0px 0px 0px',
            // marginLeft: 0,
            lineHeight: '1.4375em'
          }
        }
      }
    }
  };
}
